import { Users } from 'lucide-react';

/** Lucide icon for Clients feature branding (sidebar nav, empty states). */
export const CLIENTS_FEATURE_ICON = Users;
